var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Login-element-input LoginPassword"},[_c('BSCInput',{attrs:{"value":_vm.login_data.password,"message":_vm.$t('utils.label.password'),"placeholder":_vm.$t('login.password.placeholder'),"typeInput":"password","type":"primary"},on:{"input":_vm.inputPassword}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }